// Utilities (TypeScript)
export class Util {

  static apiBaseUrl(): string {
    return import.meta.env.MODE === "development"
      ? (import.meta.env.VITE_API_BASE as string) || ""
      : (import.meta.env.VITE_API_BASE as string) || 'https://falcon.snk.de';
  }

  static el(tag: string, text: string | null = null, cls: string | null = null): HTMLElement {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== null && text !== undefined) el.textContent = text;
    return el;
  }

  static pad(n: number): string {
    return n.toString().padStart(2, '0');
  }

  static formatHMS(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${Util.pad(h)}:${Util.pad(m)}:${Util.pad(s)}`;
  }

  static parseTimeToDate(dateStr: string, timeStr: string): Date {
    // dateStr: yyyy-mm-dd, timeStr: HH:mm
    const [y, m, d] = dateStr.split('-').map(Number);
    const [hh, mm] = timeStr.split(':').map(Number);
    return new Date(y, m - 1, d, hh, mm, 0, 0);
  }

  static toDateInputValue(date: Date): string {
    const y = date.getFullYear();
    const m = Util.pad(date.getMonth() + 1);
    const d = Util.pad(date.getDate());
    return `${y}-${m}-${d}`;
  }

  static toTimeInputValue(date: Date): string {
    return `${Util.pad(date.getHours())}:${Util.pad(date.getMinutes())}`;
  }

  static startOfWeek(date: Date): Date {
    const d = new Date(date);
    const day = (d.getDay() + 6) % 7; // Monday=0
    d.setDate(d.getDate() - day);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  static isSameDay(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  static formatJiraDateTimeLocal(date: Date): string {
    // Jira expects yyyy-MM-dd'T'HH:mm:ss.SSSZ with local timezone offset
    const pad3 = (n: number): string => n.toString().padStart(3, '0');
    const y = date.getFullYear();
    const m = Util.pad(date.getMonth() + 1);
    const d = Util.pad(date.getDate());
    const hh = Util.pad(date.getHours());
    const mm = Util.pad(date.getMinutes());
    const ss = Util.pad(date.getSeconds());
    const ms = pad3(date.getMilliseconds());
    const off = -date.getTimezoneOffset();
    const sign = off >= 0 ? '+' : '-';
    const oabs = Math.abs(off);
    const oh = Util.pad(Math.floor(oabs / 60));
    const om = Util.pad(oabs % 60);
    return `${y}-${m}-${d}T${hh}:${mm}:${ss}.${ms}${sign}${oh}${om}`;
  }

  static debounce<T extends (...args: any[]) => any>(fn: T, wait: number): (...args: Parameters<T>) => void {
    let t: NodeJS.Timeout;
    return function (this: any, ...args: Parameters<T>) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  static generateId(): string {
    return 'wl_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  static isBrowserExtension(): boolean {
    return Boolean((typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.id) || (typeof browser !== 'undefined' && browser.runtime && browser.runtime.id));
  }
}